import React, { useState, useEffect, useRef } from 'react'
import styles from './CustomSelect.module.scss'
import { ReactComponent as DownIcon } from 'components/UI/icons/arrow-down-s-line.svg'
import { ReactComponent as TemplateIcon } from 'components/UI/icons/template-icon.svg'

const CustomSelect = ({
  options,
  defaultOption,
  onSelect,
  selectedValue,
  error,
  selectKey,
  icon,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState(defaultOption)
  const selectRef = useRef(null)

  useEffect(() => {
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    setSelectedOption(defaultOption)
  }, [defaultOption])

  const handleOptionClick = (option) => {
    setSelectedOption(option.name)
    setIsOpen(false)
    onSelect(option, selectKey)
  }

  const toggleSelect = () => {
    setIsOpen(!isOpen)
  }

  const handleClickOutside = (event) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsOpen(false)
    }
  }

  return (
    <div className={styles.customSelect} ref={selectRef}>
      {icon ? (
        <div className={styles.templateIcon} onClick={toggleSelect}>
          <TemplateIcon
            style={{ transform: isOpen ? 'rotate(180deg)' : 'none' }}
          />
        </div>
      ) : (
        <div className={styles.selectHeader} onClick={toggleSelect}>
          <div
            className={`${styles.selectedOption} ${error ? styles.error : ''}`}
          >
            {selectedOption?.length > 7
              ? selectedOption?.substring(0, 7) + '...'
              : selectedOption}
          </div>
          <div className={styles.arrowIcon}>
            <DownIcon
              style={{ transform: isOpen ? 'rotate(180deg)' : 'none' }}
            />
          </div>
        </div>
      )}

      {isOpen && (
        <ul className={styles.optionsList}>
          {options.map((option, index) => (
            <li
              key={index}
              className={`${styles.option}`}
              onClick={() => handleOptionClick(option)}
            >
              {option.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default CustomSelect
